// extracted by mini-css-extract-plugin
export default {"grid":"ProductItem_grid__3ZdRp","img":"ProductItem_img__HdWtY","content":"ProductItem_content__ohnpv","details":"ProductItem_details__ReWhd","list":"ProductItem_list__+LyCC"};